// #region Global Imports
import { Button } from "@mui/material";
import styled from "styled-components";
import { theme } from "@Styled";

// #endregion Global Imports

export const Container = styled.div`
    background-color: ${({ theme }) => theme.colors.primary};
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
`;

export const Top = styled.div`
    margin: 100px;
`;

export const MainMenuWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.tbMadison};
    position: fixed;
    z-index: 10;
    width: 100%;
`;
export const GuestInnerContainer = styled.div`
    padding: 0 16px;
    width: 100%;
`;
export const Middle = styled.div`
    text-align: center;
    display: flex;
    flex: 1 1 100%;
    width: 100%;
    justify-content: flex-start;
    max-width: 1025px;
    margin: auto;
    position: relative;
    margin-top: 100px;
`;

export const MiddleLeft = styled.div`
    display: none;
    @media (min-width: 768px) {
        display: flex;
        position: fixed;
        top: 100px;
        bottom: 0;
    }
`;

export const MiddleLeftButtons = styled.div`
    background: #f9da2e;
    border-radius: 8px;
    font-family: Arial;
    font-weight: 700;
    font-size: 25px;
    color: #4b6c8d;
    letter-spacing: 0;
    width: 55px;
    height: 236px;
    margin-left: 15px;
    padding: 10px 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color: #4b6c8d;

    .button {
        cursor: pointer;
    }

    .active {
        color: #2c3e50;
    }
`;

export const MiddleRight = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    margin: 0 16px;
    @media (min-width: 768px) {
        margin: 0 16px 0 272px;
    }
`;

export const Apod = styled.div`
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
`;

export const ApodButton = styled.div`
    background: #f9da2e;
    border-radius: 5px;
    padding: 5px 10px;
    font-family: Arial;
    font-weight: 700;
    font-size: 25px;
    color: ${({ theme }) => theme.colors.primary};
    letter-spacing: 0;
`;

export const TopText = styled.div`
    font-size: 110px;
    font-family: Arial, Helvetica, sans-serif;
    color: #ffffff;
    margin-bottom: 10px;
`;

export const TendbeLogo = styled.div`
    height: 100px;
    width: 100px;
    background-repeat: none;
    background-size: contain;
    background-image: url("/images/tb-icon.png");
    margin: auto;
`;

export const TbPrimaryButton = styled(Button)`
    && {
        background-color: ${theme.palette.common.deepSkyBlue};
        color: white;
        margin-right: 0.5rem;
    }
`;
